export default __webpack_public_path__ + "static/media/shoptobuy.ddee8573.png";